// ============================================================
// bankSoalInterpretasiGambar.js — Modul "Interpretasi Gambar"
// Latihan menyerupai TAT (Thematic Apperception Test): peserta melihat
// gambar situasi ambigu lalu menuliskan (1) siapa tokoh utamanya,
// (2) sedang melakukan apa, dan (3) bagaimana perasaannya.
//
// CATATAN PENTING:
// - Seluruh ilustrasi SVG di bawah ini ORISINAL (digambar ulang dari
//   deskripsi skenario umum), BUKAN hasil scan/tiru dari kartu TAT asli
//   berhak cipta manapun.
// - TAT asli TIDAK punya jawaban benar/salah — dinilai psikolog terlatih
//   dari isi cerita. Modul ini TIDAK mengklaim bisa menilai isi karangan
//   peserta secara otomatis. Skor yang dihasilkan murni dari KELENGKAPAN
//   pengisian (apakah semua kolom diisi dengan wajar), bukan kualitas
//   ceritanya — supaya tidak ada klaim penilaian psikologis palsu.
// - "Contoh Jawaban" di tiap soal HANYA salah satu ilustrasi cara
//   menjawab yang terstruktur (tokoh/kegiatan/perasaan) — bukan satu-
//   satunya jawaban benar. Tujuannya membiasakan peserta dengan format
//   menjawab TAT supaya tidak bingung saat tes sesungguhnya.
// ============================================================

function svgBg(content) {
  return `<svg viewBox="0 0 200 140" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><rect width="200" height="140" fill="#F8FAFC" rx="8"/>${content}</svg>`;
}

// Helper siluet orang sederhana (kepala bulat + badan garis) — orisinal,
// dipakai berulang dengan posisi/pose berbeda tiap soal.
function orang(cx, cy, { warna = '#374151', skala = 1, lenganAtas = false, lenganKe = null } = {}) {
  const r = 7 * skala;
  const tinggiBadan = 34 * skala;
  const lengan = lenganAtas
    ? `<line x1="${cx}" y1="${cy + r + 8 * skala}" x2="${cx + (lenganKe || 12) * skala}" y2="${cy + r}" stroke="${warna}" stroke-width="3" stroke-linecap="round"/>`
    : `<line x1="${cx - 9 * skala}" y1="${cy + r + 18 * skala}" x2="${cx}" y2="${cy + r + 8 * skala}" stroke="${warna}" stroke-width="3" stroke-linecap="round"/><line x1="${cx + 9 * skala}" y1="${cy + r + 18 * skala}" x2="${cx}" y2="${cy + r + 8 * skala}" stroke="${warna}" stroke-width="3" stroke-linecap="round"/>`;
  return `
    <circle cx="${cx}" cy="${cy}" r="${r}" fill="${warna}"/>
    <line x1="${cx}" y1="${cy + r}" x2="${cx}" y2="${cy + r + tinggiBadan}" stroke="${warna}" stroke-width="3" stroke-linecap="round"/>
    ${lengan}
    <line x1="${cx}" y1="${cy + r + tinggiBadan}" x2="${cx - 8 * skala}" y2="${cy + r + tinggiBadan + 16 * skala}" stroke="${warna}" stroke-width="3" stroke-linecap="round"/>
    <line x1="${cx}" y1="${cy + r + tinggiBadan}" x2="${cx + 8 * skala}" y2="${cy + r + tinggiBadan + 16 * skala}" stroke="${warna}" stroke-width="3" stroke-linecap="round"/>
  `;
}

export const soalInterpretasiGambar = [
  {
    id: 'IG-001',
    judul: 'Dua Orang Berpelukan',
    gambar: svgBg(`
      <circle cx="85" cy="55" r="9" fill="#3B82F6"/>
      <circle cx="112" cy="57" r="9" fill="#F59E0B"/>
      <path d="M85,64 C75,80 80,100 95,108 C100,111 105,111 110,108 C122,100 125,80 112,66" fill="none" stroke="#3B82F6" stroke-width="3" stroke-linecap="round"/>
      <path d="M112,66 C122,80 118,98 105,107" fill="none" stroke="#F59E0B" stroke-width="3" stroke-linecap="round"/>
      <line x1="95" y1="108" x2="90" y2="124" stroke="#3B82F6" stroke-width="3" stroke-linecap="round"/>
      <line x1="102" y1="108" x2="106" y2="124" stroke="#3B82F6" stroke-width="3" stroke-linecap="round"/>
      <line x1="105" y1="107" x2="112" y2="123" stroke="#F59E0B" stroke-width="3" stroke-linecap="round"/>
    `),
    contohJawaban: {
      tokoh: 'Dua sahabat lama (bisa juga anggota keluarga) yang baru bertemu lagi setelah lama berpisah.',
      kegiatan: 'Mereka sedang berpelukan erat di suatu tempat, seolah baru saja bertemu kembali setelah waktu yang lama.',
      perasaan: 'Keduanya merasa lega, hangat, dan bahagia — ada campuran rasa haru karena rindu yang akhirnya terobati.',
    },
  },
  {
    id: 'IG-002',
    judul: 'Orang Bergelantungan',
    gambar: svgBg(`
      <line x1="20" y1="20" x2="160" y2="20" stroke="#78716C" stroke-width="4"/>
      <line x1="120" y1="20" x2="120" y2="55" stroke="#57534E" stroke-width="2.5"/>
      <circle cx="120" cy="63" r="8" fill="#EF4444"/>
      <line x1="120" y1="71" x2="120" y2="100" stroke="#EF4444" stroke-width="3" stroke-linecap="round"/>
      <line x1="120" y1="55" x2="108" y2="72" stroke="#EF4444" stroke-width="3" stroke-linecap="round"/>
      <line x1="120" y1="55" x2="132" y2="72" stroke="#EF4444" stroke-width="3" stroke-linecap="round"/>
      <line x1="120" y1="100" x2="112" y2="118" stroke="#EF4444" stroke-width="3" stroke-linecap="round"/>
      <line x1="120" y1="100" x2="128" y2="118" stroke="#EF4444" stroke-width="3" stroke-linecap="round"/>
      <path d="M30,130 Q100,138 170,130" fill="none" stroke="#A8A29E" stroke-width="2" stroke-dasharray="3,3"/>
    `),
    contohJawaban: {
      tokoh: 'Seseorang yang sedang memanjat atau berlatih di ketinggian, terlihat masih berpegangan kuat.',
      kegiatan: 'Ia sedang bergelantungan di sebuah batang/tali tinggi, mencoba mempertahankan pegangannya.',
      perasaan: 'Ada rasa tegang dan waspada, tapi juga fokus dan yakin — ia sedang berusaha keras menuntaskan tantangan ini, bukan panik sepenuhnya.',
    },
  },
  {
    id: 'IG-003',
    judul: 'Orang Tenggelam & Kapal Penyelamat',
    gambar: svgBg(`
      <rect x="0" y="90" width="200" height="50" fill="#BFDBFE" opacity="0.6"/>
      <path d="M0,92 Q20,86 40,92 T80,92 T120,92 T160,92 T200,92" fill="none" stroke="#60A5FA" stroke-width="2"/>
      <circle cx="70" cy="98" r="6" fill="#1F2937"/>
      <line x1="62" y1="104" x2="58" y2="96" stroke="#1F2937" stroke-width="2.5" stroke-linecap="round"/>
      <line x1="78" y1="104" x2="82" y2="96" stroke="#1F2937" stroke-width="2.5" stroke-linecap="round"/>
      <polygon points="145,70 175,70 165,90 155,90" fill="#78716C"/>
      <polygon points="150,45 150,70 172,70" fill="#E5E7EB" stroke="#78716C" stroke-width="1.5"/>
      <rect x="158" y="35" width="3" height="35" fill="#78716C"/>
    `),
    contohJawaban: {
      tokoh: 'Seseorang yang sedang kesulitan di air, dan sebuah kapal/tim penyelamat yang mendekat.',
      kegiatan: 'Orang itu sedang berjuang menjaga diri tetap di permukaan air sambil menunggu pertolongan datang.',
      perasaan: 'Awalnya panik dan takut, tapi mulai muncul secercah harapan begitu melihat kapal penyelamat mendekat.',
    },
  },
  {
    id: 'IG-004',
    judul: 'Sendirian di Keramaian',
    gambar: svgBg(`
      ${orang(100, 50, { warna: '#111827', skala: 1.1 })}
      ${orang(30, 60, { warna: '#D1D5DB', skala: 0.8 })}
      ${orang(55, 65, { warna: '#D1D5DB', skala: 0.7 })}
      ${orang(150, 62, { warna: '#D1D5DB', skala: 0.8 })}
      ${orang(172, 58, { warna: '#D1D5DB', skala: 0.75 })}
      ${orang(15, 45, { warna: '#E5E7EB', skala: 0.6 })}
      ${orang(185, 48, { warna: '#E5E7EB', skala: 0.6 })}
    `),
    contohJawaban: {
      tokoh: 'Seseorang yang berdiri diam di tengah banyak orang yang lalu-lalang di sekitarnya.',
      kegiatan: 'Ia berdiri sendirian, seperti sedang berpikir atau menunggu sesuatu/seseorang, sementara orang lain sibuk dengan urusannya masing-masing.',
      perasaan: 'Ada rasa sepi meski dikelilingi banyak orang, tapi juga tenang — mungkin ia sedang mengambil jeda sejenak dari keramaian.',
    },
  },
  {
    id: 'IG-005',
    judul: 'Dua Orang Berdebat',
    gambar: svgBg(`
      ${orang(70, 55, { warna: '#DC2626', skala: 1, lenganAtas: true, lenganKe: 14 })}
      ${orang(130, 55, { warna: '#1D4ED8', skala: 1, lenganAtas: true, lenganKe: -14 })}
      <path d="M92,45 Q100,38 108,45" fill="none" stroke="#9CA3AF" stroke-width="2" stroke-dasharray="2,3"/>
    `),
    contohJawaban: {
      tokoh: 'Dua rekan kerja atau teman yang sedang berbeda pendapat tentang suatu hal.',
      kegiatan: 'Mereka sedang berdiskusi dengan nada yang cukup tegang, saling mempertahankan pendapat masing-masing.',
      perasaan: 'Keduanya merasa frustrasi dan sedikit emosi, tapi masih dalam batas ingin menyelesaikan masalah, bukan bermusuhan.',
    },
  },
  {
    id: 'IG-006',
    judul: 'Menatap ke Luar Jendela',
    gambar: svgBg(`
      <rect x="120" y="20" width="60" height="70" rx="4" fill="#DBEAFE" stroke="#93C5FD" stroke-width="2"/>
      <line x1="150" y1="20" x2="150" y2="90" stroke="#93C5FD" stroke-width="2"/>
      <line x1="120" y1="55" x2="180" y2="55" stroke="#93C5FD" stroke-width="2"/>
      <rect x="30" y="90" width="60" height="10" fill="#A8A29E"/>
      ${orang(60, 78, { warna: '#4B5563', skala: 0.9 })}
    `),
    contohJawaban: {
      tokoh: 'Seseorang yang sedang duduk sendirian di dekat jendela.',
      kegiatan: 'Ia duduk diam sambil memandang keluar jendela, tampak sedang merenung atau melamun.',
      perasaan: 'Terlihat tenang tapi juga sedikit murung — mungkin sedang memikirkan sesuatu yang penting atau merindukan sesuatu.',
    },
  },
  {
    id: 'IG-007',
    judul: 'Memanjat Tebing',
    gambar: svgBg(`
      <polygon points="10,140 70,20 130,140" fill="#E7E5E4" stroke="#A8A29E" stroke-width="2"/>
      <circle cx="72" cy="55" r="7" fill="#059669"/>
      <line x1="72" y1="62" x2="72" y2="82" stroke="#059669" stroke-width="3" stroke-linecap="round"/>
      <line x1="72" y1="66" x2="60" y2="75" stroke="#059669" stroke-width="3" stroke-linecap="round"/>
      <line x1="72" y1="66" x2="84" y2="58" stroke="#059669" stroke-width="3" stroke-linecap="round"/>
      <line x1="72" y1="82" x2="62" y2="95" stroke="#059669" stroke-width="3" stroke-linecap="round"/>
      <line x1="72" y1="82" x2="80" y2="98" stroke="#059669" stroke-width="3" stroke-linecap="round"/>
    `),
    contohJawaban: {
      tokoh: 'Seseorang yang sedang mendaki/memanjat tebing yang cukup tinggi dan terjal.',
      kegiatan: 'Ia sedang berusaha keras mencari pijakan berikutnya untuk terus naik ke puncak.',
      perasaan: 'Merasa lelah tapi tetap bertekad dan optimis — yakin bisa mencapai puncak walau perjalanan berat.',
    },
  },
  {
    id: 'IG-008',
    judul: 'Persimpangan Jalan',
    gambar: svgBg(`
      <line x1="100" y1="10" x2="100" y2="130" stroke="#D1D5DB" stroke-width="10"/>
      <line x1="20" y1="70" x2="180" y2="70" stroke="#D1D5DB" stroke-width="10"/>
      <path d="M100,50 L100,20 M92,28 L100,20 L108,28" fill="none" stroke="#059669" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M60,70 L30,70 M38,62 L30,70 L38,78" fill="none" stroke="#2563EB" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M140,70 L170,70 M162,62 L170,70 L162,78" fill="none" stroke="#D97706" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
      ${orang(100, 95, { warna: '#374151', skala: 0.9 })}
    `),
    contohJawaban: {
      tokoh: 'Seseorang yang berdiri tepat di tengah persimpangan jalan dengan beberapa arah pilihan.',
      kegiatan: 'Ia sedang berhenti sejenak untuk memutuskan arah mana yang akan diambil selanjutnya.',
      perasaan: 'Merasa ragu dan sedikit bimbang, tapi juga penuh pertimbangan — sedang serius memikirkan konsekuensi tiap pilihan sebelum melangkah.',
    },
  },
];

export function getSoalInterpretasiGambar() {
  return [...soalInterpretasiGambar].sort(() => Math.random() - 0.5);
}

// Skor MURNI dari kelengkapan pengisian (bukan menilai isi karangan) —
// tiap soal punya 3 kolom (tokoh, kegiatan, perasaan). Kolom dianggap
// "terisi wajar" kalau panjang teksnya (setelah di-trim) >= 8 karakter,
// supaya sekadar mengetik satu-dua huruf asal tidak ikut dihitung.
const MIN_PANJANG_KOLOM = 8;

export function hitungSkorInterpretasiGambar(soalList, jawabanUser) {
  const byId = {};
  jawabanUser.forEach(j => { byId[j.id] = j; });

  let kolomTerisi = 0;
  const totalKolom = soalList.length * 3;
  let soalTerisiPenuh = 0;

  soalList.forEach(soal => {
    const j = byId[soal.id] || {};
    const kolomIni = ['tokoh', 'kegiatan', 'perasaan'].filter(
      f => typeof j[f] === 'string' && j[f].trim().length >= MIN_PANJANG_KOLOM
    ).length;
    kolomTerisi += kolomIni;
    if (kolomIni === 3) soalTerisiPenuh += 1;
  });

  const skor = totalKolom > 0 ? Math.round((kolomTerisi / totalKolom) * 100) : 0;
  return { skor, kolomTerisi, totalKolom, soalTerisiPenuh, totalSoal: soalList.length };
}

// ===== SOAL TAMBAHAN BARU (Interpretasi Gambar) =====
// Soal lama tetap dipertahankan. 8 skenario ambigu ORISINAL baru
// (ilustrasi dibuat sendiri, bukan tiruan kartu TAT).
soalInterpretasiGambar.push(
  {
    id: 'IG-009',
    judul: 'Orang di Depan Jendela',
    gambar: svgBg(`
      <rect x="110" y="20" width="62" height="78" fill="#FEF3C7" stroke="#78716C" stroke-width="3"/>
      <line x1="141" y1="20" x2="141" y2="98" stroke="#78716C" stroke-width="2"/>
      <line x1="110" y1="59" x2="172" y2="59" stroke="#78716C" stroke-width="2"/>
      <line x1="20" y1="124" x2="180" y2="124" stroke="#A8A29E" stroke-width="2"/>
      ${orang(78, 42, { warna: '#4B5563', skala: 0.95 })}
    `),
    contohJawaban: {
      tokoh: 'Seorang pekerja muda yang sedang sendirian di dalam ruangan.',
      kegiatan: 'Ia berdiri memandang ke arah jendela, seperti sedang memikirkan sesuatu atau menunggu seseorang datang.',
      perasaan: 'Merasa merenung dan sedikit gelisah, tetapi masih menyimpan harapan bahwa kabar baik akan datang.',
    },
  },
  {
    id: 'IG-010',
    judul: 'Dua Orang Berjabat Tangan',
    gambar: svgBg(`
      ${orang(80, 36, { warna: '#2563EB', skala: 0.95, lenganAtas: true, lenganKe: 22 })}
      ${orang(120, 36, { warna: '#D97706', skala: 0.95, lenganAtas: true, lenganKe: -22 })}
      <line x1="20" y1="124" x2="180" y2="124" stroke="#A8A29E" stroke-width="2"/>
    `),
    contohJawaban: {
      tokoh: 'Dua rekan kerja (atau dua pihak yang baru bertemu) dalam suasana formal.',
      kegiatan: 'Mereka berjabat tangan, mungkin setelah mencapai kesepakatan atau saat perkenalan.',
      perasaan: 'Keduanya merasa lega dan saling menghargai; ada rasa percaya yang baru terbangun.',
    },
  },
  {
    id: 'IG-011',
    judul: 'Orang Mendaki Lereng',
    gambar: svgBg(`
      <polygon points="10,125 190,125 190,28" fill="#D6D3D1" stroke="#78716C" stroke-width="3"/>
      <line x1="170" y1="40" x2="170" y2="20" stroke="#78716C" stroke-width="2"/>
      <polygon points="170,20 186,26 170,32" fill="#EF4444"/>
      <g transform="translate(105 78) rotate(-14)">${orang(0, -26, { warna: '#374151', skala: 0.7, lenganAtas: true, lenganKe: 14 })}</g>
    `),
    contohJawaban: {
      tokoh: 'Seorang pendaki atau orang yang sedang menjalani tantangan berat.',
      kegiatan: 'Ia berjuang mendaki lereng menuju bendera di puncak, selangkah demi selangkah.',
      perasaan: 'Lelah tetapi bertekad; ada semangat dan rasa bangga membayangkan sampai di puncak.',
    },
  },
  {
    id: 'IG-012',
    judul: 'Orang Duduk Sendiri di Bangku',
    gambar: svgBg(`
      <rect x="62" y="82" width="76" height="8" fill="#92400E"/>
      <line x1="68" y1="90" x2="68" y2="112" stroke="#92400E" stroke-width="4"/>
      <line x1="132" y1="90" x2="132" y2="112" stroke="#92400E" stroke-width="4"/>
      <circle cx="100" cy="46" r="8" fill="#4B5563"/>
      <path d="M100,54 L100,80 L118,80 L118,100" fill="none" stroke="#4B5563" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"/>
      <line x1="100" y1="64" x2="112" y2="72" stroke="#4B5563" stroke-width="3" stroke-linecap="round"/>
      <rect x="158" y="40" width="5" height="72" fill="#78350F"/>
      <circle cx="160" cy="34" r="22" fill="#86EFAC" opacity="0.9"/>
      <line x1="20" y1="124" x2="180" y2="124" stroke="#A8A29E" stroke-width="2"/>
    `),
    contohJawaban: {
      tokoh: 'Seseorang yang sedang menyendiri di taman, mungkin baru melewati hari yang berat.',
      kegiatan: 'Ia duduk diam di bangku di bawah pohon, memandang ke depan sambil berpikir.',
      perasaan: 'Merasa sepi namun tenang; ia butuh waktu untuk menenangkan diri dan menata pikiran.',
    },
  },
  {
    id: 'IG-013',
    judul: 'Tiga Orang di Sekitar Meja',
    gambar: svgBg(`
      <rect x="62" y="74" width="76" height="8" fill="#92400E"/>
      <line x1="72" y1="82" x2="72" y2="114" stroke="#92400E" stroke-width="4"/>
      <line x1="128" y1="82" x2="128" y2="114" stroke="#92400E" stroke-width="4"/>
      <rect x="86" y="66" width="28" height="8" fill="#FDE68A" stroke="#A16207" stroke-width="1"/>
      ${orang(40, 28, { warna: '#2563EB', skala: 0.85 })}
      ${orang(100, 6, { warna: '#16A34A', skala: 0.85 })}
      ${orang(160, 28, { warna: '#DC2626', skala: 0.85 })}
    `),
    contohJawaban: {
      tokoh: 'Tiga anggota tim yang sedang rapat bersama.',
      kegiatan: 'Mereka berkumpul mengelilingi meja untuk membahas dokumen atau rencana yang ada di atasnya.',
      perasaan: 'Serius dan fokus; ada rasa tanggung jawab bersama, dengan sedikit tegang karena harus mengambil keputusan.',
    },
  },
  {
    id: 'IG-014',
    judul: 'Orang di Atas Jembatan',
    gambar: svgBg(`
      <path d="M10,92 Q100,52 190,92" fill="none" stroke="#78716C" stroke-width="5"/>
      <line x1="10" y1="96" x2="190" y2="96" stroke="#78716C" stroke-width="3"/>
      <path d="M0,118 Q25,108 50,118 T100,118 T150,118 T200,118 L200,140 L0,140 Z" fill="#93C5FD"/>
      ${orang(100, 18, { warna: '#374151', skala: 0.8, lenganAtas: true, lenganKe: 12 })}
    `),
    contohJawaban: {
      tokoh: 'Seorang pelancong yang sedang berhenti di tengah perjalanan.',
      kegiatan: 'Ia berdiri di tengah jembatan sambil memandang aliran sungai di bawahnya.',
      perasaan: 'Merasa terpukau dan tenang; sejenak melepaskan beban sebelum melanjutkan perjalanan.',
    },
  },
  {
    id: 'IG-015',
    judul: 'Orang Dewasa dan Anak Berjalan',
    gambar: svgBg(`
      ${orang(80, 26, { warna: '#1D4ED8', skala: 1 })}
      ${orang(122, 56, { warna: '#F59E0B', skala: 0.6 })}
      <line x1="88" y1="58" x2="118" y2="68" stroke="#1D4ED8" stroke-width="3" stroke-linecap="round"/>
      <line x1="20" y1="124" x2="180" y2="124" stroke="#A8A29E" stroke-width="2"/>
    `),
    contohJawaban: {
      tokoh: 'Seorang ayah (atau kakak) dan seorang anak kecil.',
      kegiatan: 'Mereka berjalan berdampingan sambil bergandengan tangan menuju suatu tempat.',
      perasaan: 'Hangat dan aman; sang anak merasa terlindungi, sang dewasa merasa bertanggung jawab dan sayang.',
    },
  },
  {
    id: 'IG-016',
    judul: 'Orang Membawa Beban Menuju Pintu',
    gambar: svgBg(`
      <rect x="140" y="30" width="38" height="94" fill="#A16207" stroke="#713F12" stroke-width="3"/>
      <circle cx="170" cy="80" r="2.5" fill="#FDE68A"/>
      ${orang(76, 34, { warna: '#374151', skala: 0.95 })}
      <rect x="40" y="100" width="30" height="24" fill="#B45309" stroke="#78350F" stroke-width="2"/>
      <line x1="20" y1="124" x2="180" y2="124" stroke="#A8A29E" stroke-width="2"/>
    `),
    contohJawaban: {
      tokoh: 'Seorang pekerja yang baru pulang atau hendak berangkat membawa barang.',
      kegiatan: 'Ia berjalan menuju pintu sambil membawa kotak bawaan, bersiap memasuki ruangan.',
      perasaan: 'Lelah tetapi bertekad menyelesaikan tugas; ada campuran beban dan rasa tanggung jawab.',
    },
  },
);
